<template>
  <div
    v-if="
      (activeOffers.length > 0 || activeDateRequests.length > 0) &&
      !isOnOfferPage
    "
    class="relative flex items-center gap-1 cursor-pointer hover:underline"
    @click="toggle"
  >
    <span class="navbar-icon flex w-[22px] h-[22px] items-center">
      <div class="w-full h-full flex items-center justify-center">
        <OfferIcon class="min-w-[33px]" />
      </div>
    </span>
    <span class="hidden sm:block">{{ t('general.yourRequests') }}</span>
    <client-only>
      <div v-if="activeOffers.length > 0" class="offer-badge">
        {{ activeOffers.length }}
      </div>
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { useOfferTracking } from '~/composables/useOfferTracking'
import { useDateRequestTracking } from '~/composables/useDateRequestTracking'
import { useActiveOffersSidebarUiState } from '~/composables/useUiState'
import OfferIcon from '~/assets/icons/offers-icon.svg?component'

const { t } = useI18n()
const { activeOffers } = useOfferTracking()
const { activeDateRequests } = useDateRequestTracking()
const { toggle } = useActiveOffersSidebarUiState()

const route = useRoute()
const isOnOfferPage = computed(() => route.path.includes('/offer/'))
</script>

<style scoped lang="postcss">
.offer-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  min-width: 1rem;
  min-height: 1rem;
  padding: 2px 3px 2px 5px;
  border-radius: 9999px;
  @apply bg-red text-white;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 0.75rem;
}

.navbar-icon {
  @apply cursor-pointer;

  &:hover {
    svg {
      @apply scale-110 transition-all duration-200;
    }
  }
}
</style>
